import React, { useState, useEffect } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1651604033534-e66b281f1981",
    imageAlt: "Freshly baked golden croissants arranged on rustic wooden board with steam rising in warm morning bakery lighting",
    title: "Authentic Italian Cornetti",
    subtitle: "Freshly baked every morning at 6 AM",
    cta: "Order Now",
    badge: "Signature Item"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1732361551253-52d03322869b",
    imageAlt: "Artisan sourdough bread loaves with golden crispy crust displayed on marble counter in traditional Italian bakery setting",
    title: "Artisan Sourdough Breads",
    subtitle: "Traditional recipes passed down through generations",
    cta: "Explore Menu",
    badge: "Daily Fresh"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1698934641088-3a2c990603c6",
    imageAlt: "Elegant multi-tiered wedding cake with white fondant and fresh flower decorations displayed in professional bakery showcase",
    title: "Custom Celebration Cakes",
    subtitle: "Turn your dreams into delicious reality",
    cta: "Design Your Cake",
    badge: "Custom Orders"
  }];


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides?.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroSlides?.length]);

  const handleSlideChange = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="relative h-[600px] lg:h-[700px] overflow-hidden bg-card">
      {heroSlides?.map((slide, index) =>
      <div
        key={slide?.id}
        className={`absolute inset-0 transition-opacity duration-1000 ${
        index === currentSlide ? 'opacity-100' : 'opacity-0'}`
        }>

          <div className="absolute inset-0">
            <Image
            src={slide?.image}
            alt={slide?.imageAlt}
            className="w-full h-full object-cover" />

            <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/70 to-transparent" />
          </div>

          <div className="relative container-custom h-full flex items-center">
            <div className="max-w-2xl space-y-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20">
                <Icon name="Sparkles" size={16} color="var(--color-primary)" />
                <span className="text-sm font-medium text-primary">{slide?.badge}</span>
              </div>

              <h1 className="font-serif text-5xl lg:text-6xl font-bold text-foreground leading-tight">
                {slide?.title}
              </h1>

              <p className="text-xl text-muted-foreground max-w-xl">
                {slide?.subtitle}
              </p>

              <div className="flex flex-wrap gap-4 pt-4">
                <Link to="/menu-showcase">
                  <Button variant="default" size="lg" iconName="ShoppingBag" iconPosition="left">
                    {slide?.cta}
                  </Button>
                </Link>
                <Link to="/visit-connect">
                  <Button variant="outline" size="lg" iconName="MapPin" iconPosition="left">
                    Visit Us
                  </Button>
                </Link>
              </div>

              <div className="flex items-center gap-6 pt-4">
                <div className="flex items-center gap-2">
                  <div className="flex">
                    {[...Array(5)]?.map((_, i) =>
                  <Icon key={i} name="Star" size={20} color="var(--color-warning)" className="fill-current" />
                  )}
                  </div>
                  <span className="text-sm font-semibold text-foreground">4.7</span>
                </div>
                <div className="h-6 w-px bg-border" />
                <span className="text-sm text-muted-foreground">471+ Happy Customers</span>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3 z-10">
        {heroSlides?.map((_, index) =>
        <button
          key={index}
          onClick={() => handleSlideChange(index)}
          className={`h-2 rounded-full transition-all duration-300 ${
          index === currentSlide ? 'w-8 bg-primary' : 'w-2 bg-muted hover:bg-primary/50'}`
          }
          aria-label={`Go to slide ${index + 1}`} />

        )}
      </div>
    </section>);

};

export default HeroSection;